var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-524 -1872)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(524 1872)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(537 1885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.053,380.449a9.675,9.675,0,0,0-16.651,0,4.011,4.011,0,0,0-.03,4.076,4.055,4.055,0,0,0,3.562,2.073h9.588a4.056,4.056,0,0,0,3.562-2.073,4.012,4.012,0,0,0-.031-4.076Zm0,0",
    transform: "translate(-253.782 -345.67)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.129,375.7v10.9h4.794a4.055,4.055,0,0,0,3.562-2.073,4.012,4.012,0,0,0-.03-4.076,9.722,9.722,0,0,0-8.325-4.746Zm0,0",
    transform: "translate(-356.183 -345.67)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.945,402.716a7.822,7.822,0,0,0-13.461,0,3.4,3.4,0,0,0-.026,3.452,3.432,3.432,0,0,0,3.014,1.754h7.486a3.457,3.457,0,0,0,2.988-5.206Zm0,0",
    transform: "translate(0 -366.994)",
    fill: "#3f9cbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.243,398.879h0v9.043h3.744A3.432,3.432,0,0,0,97,406.168a3.4,3.4,0,0,0-.026-3.452,7.86,7.86,0,0,0-6.731-3.837Zm0,0",
    transform: "translate(-83.028 -366.994)",
    fill: "#3f9cbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.826,316.365a4.573,4.573,0,1,0,0,6.471,4.581,4.581,0,0,0,0-6.471Zm0,0",
    transform: "translate(-30.376 -289.845)",
    fill: "#3f9cbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.242,315.027v9.147h0a4.573,4.573,0,1,0,0-9.147Zm0,0",
    transform: "translate(-83.028 -289.845)",
    fill: "#3f9cbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.24,128.771a1.223,1.223,0,0,1-1.223-1.223v-1.806A5.416,5.416,0,0,1,31.24,115.05h9.135a5.415,5.415,0,1,1,0,10.831H35.143l-3.12,2.606a1.224,1.224,0,0,1-.784.284Zm0,0",
    transform: "translate(-23.76 -105.854)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.376,115.051h-4.559v10.831h4.559a5.415,5.415,0,1,0,0-10.831Zm0,0",
    transform: "translate(-138.761 -105.854)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.528,269.909a5.517,5.517,0,1,0,1.616,3.9A5.523,5.523,0,0,0,327.528,269.909Zm0,0",
    transform: "translate(-292.681 -246.849)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.969,0H104.742a7.293,7.293,0,1,0,0,14.586h7.773l4.67,3.9a1.223,1.223,0,0,0,2.007-.939V14.484A7.294,7.294,0,0,0,117.969,0Zm0,0",
    transform: "translate(-89.659)",
    fill: "#3f9cbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.089,0h-6.261V14.586h.807l4.67,3.9a1.223,1.223,0,0,0,2.007-.939V14.484A7.294,7.294,0,0,0,282.089,0Zm0,0",
    transform: "translate(-253.779)",
    fill: "#3f9cbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.129,268.3v11.029a5.515,5.515,0,1,0,0-11.029Zm0,0",
    transform: "translate(-356.183 -246.85)",
    fill: "#176eb5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.b1c7a9adbe4c5fe810ed246405de9d04.svg";
export { ForwardRef as ReactComponent };